// extracted by mini-css-extract-plugin
export default {"form":"form__iCaf6","row":"row__GIqwi","label":"label__bUHyS","labelText":"labelText__UomI1","textInput":"textInput__JDUxS"};